function mimeTypeFor(href: string): string | null {
    if (href.endsWith('.svg')) return 'image/svg+xml';
    if (href.endsWith('.png')) return 'image/png';
    if (href.endsWith('.ico')) return 'image/x-icon';
    return null;
}

export function applyFavicon(href: string) {
    const links = document.querySelectorAll<HTMLLinkElement>(
        'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
    );
    const mime = mimeTypeFor(href);

    if (links.length === 0) {
        const link = document.createElement('link');
        link.rel = 'icon';
        if (mime) link.type = mime;
        link.href = href;
        document.head.appendChild(link);
        return;
    }

    links.forEach((link) => {
        link.href = href;
        if (mime) {
            link.type = mime;
        } else {
            link.removeAttribute('type');
        }
    });
}
